import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApiClient } from '../../../apiClient';
import { GET_CHURN_DISTRIBUTION_QUERY_KEY } from './useGetChurnDistribution';
import { GET_SMART_COHORTS_QUERY_KEY } from './useGetSmartCohorts';

export function useRecomputeChurnScores(organizationId: string) {
  const queryClient = useQueryClient();
  const apiClient = useApiClient();

  return useMutation({
    mutationFn: async () => {
      const response = await apiClient.fetchApi<{ success: boolean }, {}>({
        method: 'POST',
        endpoint: `churn-prediction/admin/${organizationId}/recompute`,
      });
      return response;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: GET_CHURN_DISTRIBUTION_QUERY_KEY(organizationId),
      });
      queryClient.invalidateQueries({
        queryKey: GET_SMART_COHORTS_QUERY_KEY(organizationId),
      });
      // Invalidate all churn-users queries for this org
      queryClient.invalidateQueries({
        queryKey: ['churn-users', organizationId],
      });
    },
  });
}
